import type { Component } from 'vue';
import TimeOutlineIcon from '@/graphics/icons/TimeOutlineIcon.vue';
import CalendarOutlineIcon from '@/graphics/icons/CalendarOutlineIcon.vue';

export const CORPORATE_GUIDED_SELECTION = {
  JOB_POST: 'job-post',
  SEARCH: 'search',
} as const;

export type CorporateGuidedSelectionOption = (typeof CORPORATE_GUIDED_SELECTION)[keyof typeof CORPORATE_GUIDED_SELECTION];

export interface CorporateGuidedSelectionOptionConfig {
  value: CorporateGuidedSelectionOption;
  label: string;
  icon: Component;
}

export const CORPORATE_GUIDED_SELECTION_OPTIONS: CorporateGuidedSelectionOptionConfig[] = [
  {
    value: CORPORATE_GUIDED_SELECTION.JOB_POST,
    label: 'I need care soon',
    icon: TimeOutlineIcon,
  },
  {
    value: CORPORATE_GUIDED_SELECTION.SEARCH,
    label: "I'm exploring or planning ahead",
    icon: CalendarOutlineIcon,
  },
];
